<template>
  <div ref="reportContainer" id="reportContainer" style="width: 100%; height: calc(100vh - 110px);"></div>
</template>

<script>
import * as pbi from "powerbi-client";
import * as models from "powerbi-models";

export default {
  props: ["reportId"],
  data() {
    return {};
  },
  mounted() {
    this.getReportEmbedConfig();
  },
  methods: {
    getReportEmbedConfig() {
      let self = this;

      let workspaceID = self.$store.getters.getWorkspaceID;

      self
        .get(
          `PowerBI/GetReportEmbedConfig?workspaceID=${workspaceID}&reportID=${self.reportId}`
        )
        .then(r => {
          self.generateReport(r.data);
        });
    },
    generateReport(reportEmbedConfig) {
      let self = this;

      var config = {
        type: "report",
        id: reportEmbedConfig.Id,
        embedUrl: reportEmbedConfig.EmbedUrl, // 'https://app.powerbi.com/reportEmbed',
        tokenType: 1,
        accessToken: reportEmbedConfig.EmbedToken.token,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
          background: models.BackgroundType.Transparent
        }
      };

      var container = self.$refs.reportContainer;
      self.report = powerbi.embed(container, config);

      self.report.on("loaded", function(event) {});
    }
  }
};
</script>